<div class="spinner" *ngIf="showSpinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div fxLayout="row" fxLayoutAlign="center center">
  <form [formGroup]="setupMfaFormGroup" fxLayout="column" fxLayoutAlign="center center" class="mfasetup-form">
    <div class="mfasetup-wrapper" fxFill>
      <mat-card-title class="title">SETUP TWO-FACTOR AUTHENTICATION</mat-card-title>
      <div class="mfasetup-container" fxLayout="column">
        <div>
          <ul>
            <li>
              Install <a target="_blank" href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458">Microsoft Authenticator (App Store),</a>
              <a target="_blank" href="https://play.google.com/store/search?q=microsoft+authenticator&c=apps"> Microsoft Authenticator (Google Play),</a>
              <br /> or
              <a target="_blank" href="https://apps.apple.com/us/app/google-authenticator/id388497605">Google Authenticator (App Store),</a>
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"> Google Authenticator (Google Play),</a>
              application on your phone
            </li>
            <li>Open installed authenticator and scan QR code or use setup code</li>
            <li>Enter 6 digits security code from authenticator application into "Security Code" field and click
              "Submit" button</li>
          </ul>
        </div>

        <div fxLayoutAlign="start center" fxLayout="column" *ngIf="!showSpinner">
          <h3>Please scan QR code</h3>
          <img [src]="mfaSetupSettings.qrCodeSetupImageUrl" />
          <h3>Or use following setup code to get security code:</h3>
          <p>{{mfaSetupSettings.manualEntryKey}}</p>
          <div class="pin-wrapper" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <mat-form-field>
              <label class="mat-form-label">Security Code</label>
              <input matInput formControlName="securityPin" (keyup.enter)="onSubmitClick()" autofocus/>
              <mat-error
                *ngIf="setupMfaFormGroup.get('securityPin').errors && setupMfaFormGroup.get('securityPin').errors.required">
                Required Field</mat-error>
              <mat-error
                *ngIf="setupMfaFormGroup.get('securityPin').errors && !setupMfaFormGroup.get('securityPin').errors.required">
                Should contain 6 digits
              </mat-error>
            </mat-form-field>
            <button mat-raised-button type="button" class="submit-code-btn mat-raised-button mat-button-base mat-accent"
              (click)="onSubmitClick()">Submit</button>
          </div>

        </div>
      </div>
    </div>
  </form>
</div>